/* eslint-disable @typescript-eslint/ban-types */
import { openDB } from "idb"

const dbPromise = openDB("mutationDB", 1, {
    upgrade(db) {
        if (!db.objectStoreNames.contains("mutations")) {
            db.createObjectStore("mutations", { keyPath: "id", autoIncrement: true })
        }
    },
})

async function withRetry(operation: Function, retries = 3) {
    for (let i = 0; i < retries; i++) {
        try {
            return await operation()
        } catch (error) {
            if (i < retries - 1) {
                await new Promise((resolve) => setTimeout(resolve, 100)) // Wait before retry
            } else {
                throw error
            }
        }
    }
}

export const saveToIndexedDB = async (mutation: unknown, variables: unknown) => {
    await withRetry(async () => {
        const db = await dbPromise
        await db.add("mutations", { mutation, variables, timestamp: Date.now() })
    })
}

export const fetchFromIndexedDB = async () => {
    return await withRetry(async () => {
        const db = await dbPromise
        return await db.getAll("mutations")
    })
}

export const clearMutationDB = async () => {
    await withRetry(async () => {
        const db = await dbPromise
        await db.clear("mutations")
    })
}

export const removeFromIndexedDB = async (name: string) => {
    await withRetry(async () => {
        const db = await dbPromise
        const transaction = db.transaction("mutations", "readwrite")
        const store = transaction.objectStore("mutations")

        // Get all mutations and filter those that match the name
        const allMutations = await store.getAll()

        const matchingMutations = allMutations.filter(
            (mutation) => mutation.mutation.definitions[0].name.value === name
        )

        // Delete each matching mutation by its ID
        for (const mutation of matchingMutations) {
            await store.delete(mutation.id)
        }

        await transaction.done
    })
}

export const checkStorageUsage = async () => {
    if (navigator.storage && navigator.storage.estimate) {
        const { usage, quota } = await navigator.storage.estimate()

        if (usage && quota) {
            const usageRatio = usage / quota
            if (usageRatio >= 0.95) return "critical"
            if (usageRatio >= 0.9) return "warning"
        }
    }
    return "normal"
}
